var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('datepicker',{attrs:{"format":"d/MM/yyyy","value":_vm.date},on:{"input":function($event){_vm.date = _vm.$moment($event)}}}),_vm._v(" "+_vm._s(_vm.date)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }